import { render, staticRenderFns } from "./ResolveCaseSemafor.vue?vue&type=template&id=4d2c6d83&scoped=true&"
import script from "./ResolveCaseSemafor.vue?vue&type=script&lang=js&"
export * from "./ResolveCaseSemafor.vue?vue&type=script&lang=js&"
import style0 from "./ResolveCaseSemafor.vue?vue&type=style&index=0&id=4d2c6d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c6d83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
